import { Commit } from 'vuex'
import { ILandingCopyState } from './types'
import { getLandingCopyData } from '@/api/landing/landing'
import LandingGig from '@/models-ts/landing/LandingGig'
import LandingJob from '@/models-ts/landing/LandingJob'
import LandingVacancy from '@/models-ts/landing/LandingVacancy'

const getInitialState = (): ILandingCopyState => ({
  jobListPublicData: [],
  gigListPublicData: [],
  vacancyListPublicData: [],
  jobsCount: 0,
  gigsCount: 0,
  vacanciesCount: 0,
})

export default () => {
  return {
    namespaced: true,
    state: getInitialState(),
    getters: {
      jobListPublic: (state: ILandingCopyState) => state.jobListPublicData.map(LandingJob.fromServer),
      gigListPublic: (state: ILandingCopyState) => state.gigListPublicData.map(LandingGig.fromServer),
      vacancyListPublic: (state: ILandingCopyState) => state.vacancyListPublicData.map(LandingVacancy.fromServer),
    },
    mutations: {
      setJobListPublicData(state: ILandingCopyState, { items, total }: { items: Array<LX.LandingJob>; total: number }) {
        state.jobListPublicData = items
        state.jobsCount = total
      },
      setGigListPublicData(state: ILandingCopyState, { items, total }: { items: Array<LX.LandingGig>; total: number }) {
        state.gigListPublicData = items
        state.gigsCount = total
      },
      setVacancyListPublicData(state: ILandingCopyState, { items, total }: { items: Array<LX.LandingVacancy>; total: number }) {
        state.vacancyListPublicData = items
        state.vacanciesCount = total
      },
    },
    actions: {
      async getLandingData({ commit }: { commit: Commit }) {
        try {
          const result = await getLandingCopyData()
          commit('setJobListPublicData', result.jobs)
          commit('setGigListPublicData', result.gigs)
          commit('setVacancyListPublicData', result.vacancies)
          commit('blog/setLastPostsData', result.blog, { root: true })
        } catch (e) {
          console.log('Error fetching landing data', e)
          commit('setJobListPublicData', { items: [], total: 0 })
          commit('setGigListPublicData', { items: [], total: 0 })
          commit('setVacancyListPublicData', { items: [], total: 0 })
          commit('blog/setLastPostsData', [], { root: true })
        }
      },
    },
  }
}
